import { render } from "./AccountSidebarMenu.vue?vue&type=template&id=957d7ff0&scoped=true&lang=html"
import script from "./AccountSidebarMenu.vue?vue&type=script&lang=js"
export * from "./AccountSidebarMenu.vue?vue&type=script&lang=js"

import "./AccountSidebarMenu.vue?vue&type=style&index=0&id=957d7ff0&scoped=true&lang=scss"

import exportComponent from "/Users/richken/code/StoryPhonesWebsite/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-957d7ff0"]])

export default __exports__